import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import Panel from '../components/Panel';

const templates = [
  { type: 'pricebook', title: 'Pricebook', details: 'Columns: sku, price' },
  { type: 'inventory', title: 'Inventory', details: 'Columns: sku, quantity' },
  {
    type: 'catalog',
    title: 'Catalog',
    details: 'Sheets: Products, Variations, Categories, Assignments, CustomAttributes · English + Arabic'
  }
];

const TemplatesPage = () => (
  <Box sx={{ maxWidth: 1440, mx: 'auto' }}>
    <Typography variant="caption" color="text.secondary">Files</Typography>
    <Typography component="h1" variant="h5" sx={{ fontWeight: 750, mb: 2 }}>Templates</Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' }, gap: 1.75 }}>
      {templates.map(template => (
        <Card key={template.type} variant="outlined" sx={{ borderRadius: '14px', borderColor: 'divider' }}>
          <CardContent sx={{ p: 2.5 }}>
            <Typography variant="h6" sx={{ fontWeight: 750 }}>{template.title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ minHeight: 48, mt: 1 }}>
              {template.details}
            </Typography>
            <Button
              component="a"
              href={`/api/templates/${template.type}`}
              variant="contained"
              startIcon={<DownloadOutlinedIcon />}
              sx={{ mt: 2 }}
            >
              Download
            </Button>
          </CardContent>
        </Card>
      ))}
    </Box>
    <Panel sx={{ mt: 2 }} bodySx={{ color: 'text.secondary' }}>
      Templates use the same column names as the file checker.
    </Panel>
  </Box>
);

export default TemplatesPage;
